// extracted by mini-css-extract-plugin
module.exports = {"tabela":"Gasto_tabela__xTO3x","header-table":"Gasto_header-table__14Khz","descricao":"Gasto_descricao__3s2-7","header":"Gasto_header__1AY2-"};